import { Toolbar } from "@mui/x-data-grid-pro";
import type { FC } from "react";
import { ExportMenu } from "./export-menu";

export const CsvExportButton: FC = () => {
  return (
    <Toolbar>
      <ExportMenu />
    </Toolbar>
  );
};
